app.service('FreshModal', [
    '$uibModal', '$q', 'AuthService', '$state',
    function ($uibModal, $q, AuthService, $state) {
        function getUserDataPromise() {
            // $state.go($state.current.name, {modal: 1}, {notify: false});

            var q = $q.defer();
            AuthService.getUserData().then(function (user) {
                q.resolve(user);
            });
            return q.promise;
        }

        return {
            open: function (params) {
                params.windowTemplateUrl = _pb + 'student-new/modal-layout.html';
                params.openedClass = "theme ";
                params.windowTopClass = "higher-z-index ";
                return getUserDataPromise()
                    .then(function (user) {
                        params.windowTopClass += user.userConfig.theme ? user.userConfig.theme : 'light';

                        return $uibModal.open(params).result;
                    });
            }
        };
    }

]);